// Auto-authored hardscape facts per city — used by paver + concrete-sealing landing pages.
export type HardscapeFact = {
  city: string;
  slug: string;
  angle: string;
  local: string;
  hoods: string[];
};

export const HARDSCAPE_FACTS: HardscapeFact[] = [
  {
    "city": "Albany",
    "slug": "albany",
    "angle": "Albany hardscapes run the full range — brick-paver walkways in Center Square, big bluestone-and-paver patios out toward Slingerlands, and 20-year-old driveway aprons in Pine Hills that have never been re-sanded.",
    "local": "City lots drain slowly, mature maples drop tannin-heavy leaf litter all fall, and plow salt off New Scotland and Delaware Ave gets tracked right onto walkways.",
    "hoods": [
      "Center Square",
      "Pine Hills",
      "Buckingham Pond",
      "Mansion District",
      "New Scotland",
      "Delmar",
      "Slingerlands",
      "Loudonville"
    ]
  },
  {
    "city": "Schenectady",
    "slug": "schenectady",
    "angle": "Stockade District brick, GE Realty Plot walkways, and newer paver patios out toward Niskayuna all sit on soil that heaves hard every February.",
    "local": "Older Schenectady installs were often laid on thin bases with plain masonry sand, so joints wash out fast and edges start to creep after a decade of freeze-thaw.",
    "hoods": [
      "Stockade District",
      "GE Realty Plot",
      "Union Street",
      "Mont Pleasant",
      "Rotterdam",
      "Glenville",
      "Scotia",
      "Niskayuna border"
    ]
  },
  {
    "city": "Clifton Park",
    "slug": "clifton-park",
    "angle": "Clifton Park is paver country — most of Country Knolls, Van Patten Woods, and Ashdown Woods went in with large paver patios, fire-pit surrounds, and paver walkways during the 2000s build-out.",
    "local": "Those patios are now 15–25 years old: the original joint sand is gone, moss has moved into the shaded backyards near Vischer Ferry, and pavers rock underfoot at the edges.",
    "hoods": [
      "Country Knolls",
      "Longkill",
      "Van Patten Woods",
      "Ashdown Woods",
      "Vischer Ferry",
      "Rexford",
      "Jonesville",
      "Halfmoon border"
    ]
  },
  {
    "city": "Saratoga Springs",
    "slug": "saratoga-springs",
    "angle": "Saratoga hardscape is high-visibility — Broadway-adjacent brick walks, North Broadway estate patios, and Geyser Crest paver drives that guests see before they see the house.",
    "local": "Sulphur-rich groundwater, heavy tree cover on the East Side, and a long tourist season mean owners here want a wet-look or natural-matte sealed finish that photographs well and holds up.",
    "hoods": [
      "Downtown / Broadway",
      "North Broadway",
      "East Side",
      "Geyser Crest",
      "Wilton",
      "Greenfield",
      "Saratoga Lake",
      "Ballston Spa area"
    ]
  },
  {
    "city": "Troy",
    "slug": "troy",
    "angle": "Troy pavers sit against brick and brownstone — Washington Park courtyards, Pottery District patios, and Sycaway driveways on steep, north-facing grades.",
    "local": "Hillside runoff pushes joint sand downhill, and the city's shaded, damp microclimate lets moss establish in walkway joints within a couple of seasons.",
    "hoods": [
      "Washington Park",
      "Pottery District",
      "Little Italy",
      "Sycaway",
      "Lansingburgh",
      "South Troy",
      "Downtown Troy",
      "Brunswick border"
    ]
  },
  {
    "city": "Colonie",
    "slug": "colonie",
    "angle": "Colonie has thousands of paver walkways, stoops, and rear patios across Loudonville, Shaker Heights, Newtonville, and the Wolf Rd corridor.",
    "local": "Flat lots hold water after storms, and salt from the Central Ave and Wolf Rd corridors gets carried onto front walks all winter — a fast route to white efflorescence haze on unsealed pavers.",
    "hoods": [
      "Loudonville",
      "Newtonville",
      "Roessleville",
      "Shaker Heights",
      "Boght Corners",
      "Maplewood",
      "Wolf Rd area",
      "Latham border"
    ]
  },
  {
    "city": "Latham",
    "slug": "latham",
    "angle": "Latham patios and walkways span three build eras — 1970s brick stoops around Latham Circle, 1990s concrete pavers off Shaker Rd, and newer large-format slabs out toward Boght and Verdoy.",
    "local": "Sandy Boght-area soil drains fast but lets edges settle, while clay pockets near Maple Ave hold water and push pavers up over winter.",
    "hoods": [
      "Latham Circle",
      "Boght",
      "Verdoy",
      "Shaker Rd area",
      "Maple Ave corridor",
      "Old Loudon Rd",
      "Newtonville border",
      "Watervliet Shaker Rd"
    ]
  },
  {
    "city": "Niskayuna",
    "slug": "niskayuna",
    "angle": "Niskayuna homes off Balltown Rd, Rosendale, and Van Antwerp are full of mature paver patios, pool decks, and long paver walkways installed during the 1990s and 2000s.",
    "local": "Deep tree canopy along River Rd and Rosendale keeps hardscape damp for days, so green algae film and joint moss are the number-one complaint here.",
    "hoods": [
      "Balltown Rd corridor",
      "Rosendale",
      "Van Antwerp",
      "Aqueduct",
      "Stanford Heights",
      "River Rd corridor",
      "Glenridge Rd area",
      "Schenectady border"
    ]
  },
  {
    "city": "Guilderland",
    "slug": "guilderland",
    "angle": "Westmere and McKownville subdivisions, plus larger lots out toward Altamont and Guilderland Center, are loaded with paver patios and fire-pit sitting areas.",
    "local": "Runoff off the Normanskill corridor and the Watervliet Reservoir area keeps low patios wet, and heavy pollen every May feeds surface algae on unsealed pavers.",
    "hoods": [
      "Westmere",
      "McKownville",
      "Altamont",
      "Guilderland Center",
      "Route 20 corridor",
      "Western Ave corridor",
      "Normanskill corridor",
      "Meadowdale"
    ]
  },
  {
    "city": "Delmar",
    "slug": "delmar",
    "angle": "Delmar, Slingerlands, and Elsmere have some of the best-kept hardscape in Bethlehem — bluestone-and-paver walks, side patios, and paver aprons off Delaware and Kenwood Ave.",
    "local": "Big shade trees and slow-draining Cherry Hill-area soil keep joints damp, and years of shoveling and salting the front walk grinds joint sand out fast.",
    "hoods": [
      "Slingerlands",
      "Elsmere",
      "Glenmont",
      "Delaware Ave corridor",
      "Kenwood Ave corridor",
      "Cherry Hill",
      "Normanside",
      "Four Corners"
    ]
  },
  {
    "city": "Ballston Spa",
    "slug": "ballston-spa",
    "angle": "Village-core brick walks off Front St plus newer paver patios out toward Malta, Milton, and Ballston Lake make up most of the hardscape here.",
    "local": "Kayaderosseras Creek humidity and heavy winter salt on Route 50 mean pavers here see both biological growth and salt-driven surface pitting.",
    "hoods": [
      "Front St / Village Core",
      "Milton",
      "Malta",
      "Ballston Lake",
      "Burnt Hills",
      "West High St",
      "Route 50 corridor",
      "Charlton border"
    ]
  },
  {
    "city": "Rensselaer",
    "slug": "rensselaer",
    "angle": "Rensselaer, East Greenbush, and Defreestville hardscape ranges from compact city walkways to full paver patios and pool surrounds on the newer East Greenbush builds.",
    "local": "Hudson riverfront humidity plus hillside runoff off Route 4 and Route 151 wash joint sand out of walkways and let algae take hold on shaded slabs.",
    "hoods": [
      "Downtown Rensselaer",
      "East Greenbush",
      "North Greenbush",
      "Defreestville",
      "Wynantskill",
      "Sand Lake",
      "Averill Park",
      "Route 4 corridor"
    ]
  }
];
